import ReactDOM from 'react-dom'

import Carousel from './carousel'

const REALTIME_IMGS = [
  '/img/elite/boxes/realtime1_2.png',
  '/img/elite/boxes/realtime2_2.png',
  '/img/elite/boxes/realtime3.jpg',
]

const CHART_IMAGES = [
  'img/elite/boxes/charts1.jpg',
  'img/elite/boxes/charts3.jpg',
  'img/elite/boxes/charts2.jpg',
  'img/elite/boxes/charts4.jpg',
]

const SCREENER_IMAGES = ['img/elite/boxes/screener1.jpg', 'img/elite/boxes/screener2.jpg']

const realtimeCarousel = document.getElementById('carousel-realtime')
const chartsCarousel = document.getElementById('carousel-charts')
const screenerCarousel = document.getElementById('carousel-screener')

ReactDOM.render(<Carousel images={REALTIME_IMGS} />, realtimeCarousel)
ReactDOM.render(<Carousel images={CHART_IMAGES} />, chartsCarousel)
ReactDOM.render(<Carousel images={SCREENER_IMAGES} />, screenerCarousel)

function animateScroll(source: Element | null, target: HTMLElement | null) {
  if (!target) return

  source?.addEventListener('click', (ev) => {
    ev.preventDefault()

    window.scroll({
      top: target?.offsetTop,
      behavior: 'smooth',
    })
  })
}

// Animate scroll on subscribe click
const subscribeButton = document.querySelector('.elite-header .elite-button-monthly')
const subscribeTarget = document.getElementById('subscribe')
animateScroll(subscribeButton, subscribeTarget)

// Animate scroll on features click
const featuresButton = document.querySelector('.elite-scroll-down')
const featuresTarget = document.getElementById('features')
animateScroll(featuresButton, featuresTarget)

/**
 * Add interactions to server-rendered feature boxes
 */
function initEliteBoxes() {
  const boxes = document.querySelectorAll('.elite-box')

  function toggleBox(ev: Event, element?: Element) {
    ev.stopPropagation()

    // Close prev box
    document.querySelector('.elite-box.is-expanded')?.classList.remove('is-expanded')

    // Open new box
    element?.classList.add('is-expanded')
    element?.scrollIntoView({ behavior: 'smooth' })
  }

  boxes.forEach((box, index) => {
    const nextButton = box.querySelector('.elite-box_next')
    const prevButton = box.querySelector('.elite-box_prev')
    const closeButton = box.querySelector('.elite-box_close')

    box.addEventListener('click', (ev) => toggleBox(ev, box))
    nextButton?.addEventListener('click', (ev) => toggleBox(ev, boxes[index + 1]))
    prevButton?.addEventListener('click', (ev) => toggleBox(ev, boxes[index - 1]))
    closeButton?.addEventListener('click', (ev) => toggleBox(ev))
  })

  function clickArrowButton(selector: string) {
    const button: HTMLAnchorElement | null = document.querySelector(`.elite-box.is-expanded ${selector}`)

    button?.click()
  }

  document.addEventListener('keyup', (ev) => {
    switch (ev.key) {
      case 'ArrowLeft':
        return clickArrowButton('.elite-box_prev')
      case 'ArrowRight':
        return clickArrowButton('.elite-box_next')
    }
  })
}

if (!FinvizSettings.hasUserPremium) {
  initEliteBoxes()
}
